<template>
  <div >
    <el-row :gutter="20" style="margin-bottom:10px;">
      <el-col>
        <span class="fs-14 secondary-text">{{$t('common.totalField')}} {{stats.count}} </span>
        <span class="fs-14 secondary-text" style="margin-left:20px;" v-if="isFiltered">{{$t('common.totalFilteredField')}} {{count}} <el-link type="text" @click="resetFilters"><i class="mdi mdi-filter-remove"/></el-link></span>
      </el-col>
    </el-row>
    <div style="margin:10px;">
      <el-input
        prefix-icon="el-icon-search"
        :placeholder="$t('purchase_orders.search')"
        clearable
        v-model="search"
        v-popover:popover>
        <el-dropdown slot="append" style="border-right:1px;">
            <el-button type="primary">
            {{$t('common.sortBy')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :icon="sortIcon('vendor.name')" @click.native="sortBy('vendor.name')">{{$t('purchase_orders.sorting.providerName')}}</el-dropdown-item>
            <el-dropdown-item :icon="sortIcon('po_number')" @click.native="sortBy('po_number')">{{$t('purchase_orders.sorting.poNumber')}}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('created_at')" @click.native="sortBy('created_at')">{{$t('purchase_orders.sorting.creationDate')}}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('updated_at')" @click.native="sortBy('updated_at')">{{$t('purchase_orders.sorting.uupdate')}}</el-dropdown-item>
            <el-dropdown-item  :icon="sortIcon('date')" @click.native="sortBy('date')">{{$t('purchase_orders.sorting.poDate')}}</el-dropdown-item>
            </el-dropdown-menu>
            </el-dropdown>
        <el-button slot="prepend" @click="showFilters=true"><i class="mdi mdi-filter-variant" style="font-size:15px;"></i></el-button>
      </el-input>
    </div>

    <div class="box grow item-list" :style="getHeightStyle" v-loading="loading" v-if="mode=='tile'">
      <div class="infinite-list" v-infinite-scroll="load" :infinite-scroll-distance="100" infinite-scroll-distance="400" style="overflow:auto;" :style="getHeightStyle">
        <div v-for="(po, index) in purchaseOrders" :key="po.id" class="flex item" style="margin:10px;" :class="{ active : active_el == po.id  }" @click="selectPO(po,index)">
        <div class="box grow flex column justify-center p-10 info">
            <span style="margin-bottom:10px;">{{po.vendor.usual_name || po.vendor.name}}</span>
            <span class="fs-14 secondary-text" style="margin-bottom:5px;margin-left:5px;">{{po.po_number}}</span>
            <span class="fs-14 secondary-text" style="margin-bottom:5px;margin-left:5px;" v-if="po.reference">{{ $t('common.referenceField') }} {{po.reference}}</span>
            <span class="fs-14 secondary-text" style="margin-left:5px;font-style:italic;">{{moment(po.date)}}</span>
        </div>
        <div class="overdue flex p-10" style="flex-direction:column">
          <span class="" style="text-align:right;">{{$n(po.total,'currency',getCurrency(po.vendor))}}</span>
          <span class="fs-14 secondary-text" style="text-align:right;">{{$t("purchase_orders.statuses."+po.status.code)}}</span>
          <span v-if="po.billedStatus!=null" class="fs-14 secondary-text" style="text-align:right;">{{$t("purchase_orders.statuses."+po.billedStatus.code)}}</span>
        </div>
      </div>
      </div>
    </div>
    <div v-else>
      <el-table
      :data="purchaseOrders"
      stripe
      v-loading="loading"
      :height="getHeight"
      :cell-style="{padding:'2px'}"
      :empty-text="$t('purchase_orders.noPurchaseOrders')"
      style="width: 100%">
      <el-table-column
        prop="po_number"
        :label="$t('purchase_orders.purchaseOrderNumber')"
        width="160">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.id" :path="'/inventories/'+ inventoryId+'/purchase-orders/'" :label="scope.row.po_number"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('purchase_orders.Reference')"
        prop="reference"
        width="160">
      </el-table-column>
      <el-table-column
        prop="date"
        label="Date"
        width="100">
        <template slot-scope="scope">
          <span>{{moment(scope.row.date)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="customer.name"
        :show-overflow-tooltip="true"
        :label="$t('purchase_orders.provider')">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.vendor.id" path="/customers/" :label="customerName(scope.row.vendor)"></PortausLink>
        </template>

      </el-table-column>
      <el-table-column
        prop="reception_planning_date"
        :label="$t('purchase_orders.expectedDeliveryDate')"
        width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.reception_planning_date != null">{{moment(scope.row.reception_planning_date)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="total"
        :show-overflow-tooltip="true"
        align="center"
        :label="$t('common.amount')"
        width="150">
        <template slot-scope="scope">
          <span>{{$n(scope.row.total,'currency',getCurrency(scope.row.vendor))}}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="status.code"
        :label="$t('common.status')"
        align="center"
        width="190"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="fs-14 secondary-text" style="text-align:right;">{{$t("purchase_orders.statuses."+scope.row.status.code)}}</span><br>
          <span v-if="scope.row.billedStatus!=null" class="fs-14 secondary-text" style="text-align:right;">{{$t("purchase_orders.statuses."+scope.row.billedStatus.code)}}</span>
        </template>
      </el-table-column>

      <infinite-loading
        slot="append"
        ref="infiniteLoading"
        @infinite="load"
        force-use-infinite-wrapper=".el-table__body-wrapper">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </el-table>
    </div>
    <PurchaseOrderFilter :visible="showFilters" direction="ltr" @close="showFilters=false"></PurchaseOrderFilter>
  </div>
</template>
<script>
  import PurchaseOrderFilter from './purchase-order-filter'
  import PurchaseOrderAPI from '@/services/API/purchase-order'
  import moment from 'moment-timezone'
  import PortausLink from '@/components/portaus-link'
  import { mapActions, mapState, mapGetters } from 'vuex';

  export default {
    name: 'Purchase-Orders-List',
    props: {
  		inventoryId : {type : String},
      height: {type : Number}
  	},
    data() {
      return {
        stats : {
          count  :0
        },
        // poLoading : true,
        showFilters : false,
        po : null,
        index : null,
        active_el : null,
        itemsListHeight:0,
        showPo: true,
        window: {
          width: 0,
          height: 0
        },
        icons : {
          'DESC' : 'el-icon-caret-bottom',
          'ASC' : 'el-icon-caret-top'
        }
      };
    },components: {
      PortausLink,
      PurchaseOrderFilter
    },
  	methods: {
      load($state) {
  			if(this.page <= this.pages){
  				this.fetchNextPurchaseOrdersPage()
  					.then(()=>{
  						if($state){
  							$state.loaded();
  						}
  					})
  			}else{
  				if($state)$state.complete();
  			}

      },
      handlePageChange(val){
        this.changePage(val);
      },
      formatAmount(amount){
        return parseFloat(amount).toFixed(2);
      },
      calculatePOTotalAmount(po){
        return po.total_amount_items+po.adjustment;
      },
      sortBy(orderName){

        if(this.orderByModel.orderName!=orderName){
          this.orderByModel={orderName : orderName, direction:'DESC'};
          this.sortIconModel = this.icons['DESC'];
        }else{
          if(this.orderByModel.direction=='DESC'){
            this.orderByModel={orderName : orderName, direction:'ASC'};
            this.sortIconModel = this.icons['ASC'];
          }else{
            this.orderByModel={orderName : orderName, direction:'DESC'};
            this.sortIconModel = this.icons['DESC'];
          }
        }
      },
      sortIcon(orderName){
        return orderName==this.orderBy.orderName?this.sort_icon:'';
      },
      selectPO(po,index){
        this.active_el=po.id;
        this.$emit('select',po,index);
      },
      moment(datetime){
  			return  moment(datetime).format('l');
  		},
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      getCurrency(vendor){
        return vendor!=null && vendor.currency!=null ? vendor.currency.code : 'CAD';
      },
      loadCount(){
  			PurchaseOrderAPI.fetchPurchaseOrders({count:'', inventoryId : this.inventoryId})
  				.then(stats=>{
  					this.stats.count = stats.count;
  				})
  		},
      ...mapActions('purchaseOrders',['setOrderBy','setSortIcon','setSearchTerms','changePage','fetchNextPurchaseOrdersPage','resetFilters'])
  	},
  	computed: {
      orderByModel : {
  			set(val){this.setOrderBy(val)},
  			get(){return this.orderBy}
  		},
      sortIconModel : {
        set(val){this.setSortIcon(val)},
  			get(){return this.sort_icon}
      },
      search : {
          set(val){ this.setSearchTerms(val)},
          get(){return this.searchTerms}
      },
      getHeight(){
        return this.window.height-280;
      },
      getHeightStyle(){
        return "height:" + this.getHeight + "px;";
      },
      ...mapGetters('customers', ['customerName']),
      ...mapGetters('purchaseOrders',['isFiltered']),
      ...mapState('purchaseOrders',['loading','purchaseOrders','orderBy','sort_icon','searchTerms','page','pages','limit','count','mode'])
  	},
    mounted(){
      this.loadCount();
    },
    watch : {
      inventoryId : function(val){
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
        this.loadCount();
        this.$emit('inventory-change');
      }
    },
  	created(){
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
  </script>

  <style lang="scss" scoped>
  @import '../../../../assets/scss/_variables';


  .active{
    background-color: lighten($background-color, 20%);
    border-radius: 5px;
    box-shadow:none;
    box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
  }


  .item-list {
    //margin: 0 auto;
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;

    .item {
      margin: 10px 0;
      padding: 5px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all .5s .25s;


      .info {
        word-break: break-word;

      }

      &:hover {
        //margin: 15px -20px;
        //padding: 10px;
        background-color: lighten($background-color, 20%);
        border-radius: 5px;
        box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

      }

    }
  }

  </style>
